import service from "ember-engines-router-service/services/engine-router-service";
export default service;
